module.exports = __webpack_public_path__ + "img/motuo.78072e7a.png";